import { Entity } from "../helpers/Entity"


type EmailAttributes = {
    sentAt : string
}

export type EmailDto = {
    id: string
    attributes: EmailAttributes
}

export default class Email implements Entity {

    attributes: EmailAttributes
    dto : EmailDto
    id : string

    constructor(dto: EmailDto) {
        this.attributes = dto.attributes
        this.dto = dto
        this.id = dto.id
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.id != undefined
    }

    getId(): string {
        return this.dto.id
    }

    getSentAt(): string {
        return this.dto.attributes.sentAt
    }


}


// WEBPACK FOOTER //
// ./src/state/proposal/Email.ts